import React, { useState } from 'react';
import { InfoIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface TooltipProps {
  content: string;
  children?: React.ReactNode;
}
export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children
}) => {
  const [isVisible, setIsVisible] = useState(false);
  return <div className="relative inline-flex items-center" data-id="element-547">
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} className="cursor-help" data-id="element-548">
        {children || <InfoIcon className="h-3.5 w-3.5 text-gray-400 hover:text-gray-600 transition-colors" data-id="element-549" />}
      </div>
      <AnimatePresence data-id="element-550">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 5
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: 5
      }} transition={{
        duration: 0.15
      }} className="absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50 pointer-events-none" data-id="element-551">
            <div className="bg-gray-900 text-white text-[11px] normal-case rounded-none px-3 py-2 shadow-lg max-w-xl whitespace-normal" data-id="element-552">
              {content}
              <div className="absolute bottom-full left-1/2 -translate-x-1/2 -mb-1" data-id="element-553">
                <div className="border-4 border-transparent border-b-gray-900" data-id="element-554" />
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
};